import {td_status} from "../../api/td_status.api"

const state = {
    td_status: [],
}

const mutations = {
    set_td_status(state, td_status) {
        state.td_status = td_status
    }
}

const actions = {
    get_td_status(context) {
        return new Promise((resolve, reject) =>
            td_status()
                .then((response) => {
                    if (response.status == '200') {
                        let td_status = response.data;
                        context.commit('set_td_status', td_status)
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    }
}

const getters = {

    get_td_status_score: state => (id) => {
        return state.td_status.filter(function(td_status) {
            return td_status.id == id
        })[0].score;

    },

    get_td_status_reference: state => (id) => {
        return state.td_status.filter(function(td_status) {
            return td_status.id == id
        })[0].reference;

    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}